import { http, HttpResponse, delay } from 'msw';

import {
  CreateShipmentWorkflow as ShipmentDto,
  LegacyQRCodeShipment as LegacyQRCodeShipmentDto,
  QRCodeShipmentStatusEnum,
  UPSCESStatusEnum,
  UPSResponseModel as UpsResponseDto,
} from '@electricjs/core_entity-client';

import { mockInitialShipments } from '@/mocks/data/shipmentData';

// Light in-memory state so a created shipment shows up in the follow-up list.
const shipments: LegacyQRCodeShipmentDto[] = [...mockInitialShipments];

export const shipmentHandlers = [
  http.get('*/v1/shipments/tracking/:trackingNumber', async ({ params }) => {
    const response: UpsResponseDto = {
      tracking_number: params.trackingNumber as string,
      status: UPSCESStatusEnum.Delivered,
      status_description: 'Delivered',
      delivery_date: '2026-05-12',
    };
    await delay();
    return HttpResponse.json(response, { status: 200 });
  }),

  http.get(
    '*/v1/organizations/:organizationId/shipments',
    async ({ request }) => {
      const statuses = new URL(request.url).searchParams.getAll('statuses');
      const results = statuses.length
        ? shipments.filter(
            shipment => shipment.status && statuses.includes(shipment.status)
          )
        : shipments;

      await delay();
      return HttpResponse.json(
        { results, total: results.length },
        { status: 200 }
      );
    }
  ),

  http.post(
    '*/v1/organizations/:organizationId/shipments',
    async ({ request, params }) => {
      const body = (await request.json()) as ShipmentDto;
      const now = new Date().toISOString();
      shipments.unshift({
        id: crypto.randomUUID(),
        organization_id: params.organizationId as string,
        status: QRCodeShipmentStatusEnum.Pending,
        asset_id: body.asset_id,
        device_name: body.device_name,
        device_serial_number: body.serial_number,
        shipper_employee_name: body.sender_name,
        shipper_employee_email: body.sender_email,
        administrator_update_email: body.administrator_email,
        ship_to_electric_warehouse: body.ship_to_electric_warehouse,
        created_at: now,
        updated_at: now,
      });

      await delay();
      return new HttpResponse(null, { status: 201 });
    }
  ),
];
